<fieldset class="form-field__fieldset">
  <legend
    class="form-field__label form-field__text-label"
    [class.form-field__label--error]="showError"
  >
    {{ field?.label | translateInline }}
  </legend>
  <div class="flex">
    <div class="no-right-spacing sm:no-right-spacing w-16">
      <label for="countryCode" class="hidden">country code</label>
      <input
        id="countryCode"
        [ngModel]="countryCode()"
        (ngModelChange)="_updateCountryCode($event)"
        class="form-field__input form-field__text-input"
        [class.form-field__input--error]="showError"
        [class.form-field__text-input--disabled]="isDisabled"
        [class.form-field__text-input--readonly]="isReadonly"
        [disabled]="isReadonly"
        type="tel"
        inputmode="numeric"
        pattern="\+[0-9]{1,3}"
        [attr.autocomplete]="autocomplete()"
        (blur)="_onTouched()"
      />
    </div>
    <div class="no-left-spacing sm:no-left-spacing flex-1">
      <label for="phoneNumber" class="hidden">phone number</label>
      <input
        id="phoneNumber"
        [ngModel]="phoneNumber()"
        (ngModelChange)="_updatePhoneNumber($event)"
        class="form-field__input form-field__text-input"
        [class.form-field__input--error]="showError"
        [class.form-field__text-input--disabled]="isDisabled"
        [class.form-field__text-input--readonly]="isReadonly"
        [type]="inputType"
        [attr.inputmode]="inputMode"
        [disabled]="isReadonly"
        [attr.autocomplete]="autocomplete()"
        (blur)="_onTouched()"
      />
    </div>
  </div>

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      <div>
        {{ control.errors | declarativeErrorMessage: field : declaration }}
      </div>
    }
  </div>
</fieldset>
